import { openDB, IDBPDatabase } from 'idb';

export type MyDataType = any;

const DB_NAME = 'agentDB';
const STORE_NAME = 'myStore';

let dbPromise: Promise<IDBPDatabase> | null = null;


export const getDB = (): Promise<IDBPDatabase> => {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME);
                }
            },
        });
    }
    return dbPromise;
};

export const saveData = async (key: string, value: MyDataType): Promise<void> => {
    const db = await getDB();
    await db.put(STORE_NAME, value, key);
};

export const loadData = async (key: string): Promise<MyDataType | undefined> => {
    const db = await getDB();
    return await db.get(STORE_NAME, key);
};

export const deleteData = async (key: string): Promise<void> => {
    const db = await getDB();
    await db.delete(STORE_NAME, key);
};

export const clearAllData = async (): Promise<void> => {
    const db = await getDB();
    await db.clear(STORE_NAME);
};
